import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalOptionsEpisodes.scss';
import { Grid, cls } from '../../packages/components';
import EpisodesManager from '../EpisodeSelection/EpisodesManager';

const ModalOptionsEpisodes = ({ data = {}, group_id = null, title = '', history = null, handleClose = null, changeContentfromSelector = null, dataAfterBack = null}) => {
    const modalProps = {
        childrenClassName: 'modal_full_height_options_episodes'
    };
    return (
        <ModalWrapper {...modalProps}>
            <Grid className={cls(`aaf-main-modal-options-episodes`)}>
                <EpisodesManager data={data} group_id={group_id} title={title} history={history} handleClose={handleClose} changeContentfromSelector={changeContentfromSelector} dataAfterBack={dataAfterBack}></EpisodesManager>
            </Grid>
        </ModalWrapper>
    );
};

export default withOnClose(ModalOptionsEpisodes);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalOptionsEpisodes.jsx